const features = [
  {
    id: 1,
    titlePl: "Buty sportowe",
    titleEn: "Sneakers",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Modern%20chunky%20sneakers%20on%20light%20terracotta%20surface%20with%20green%20plant%20shadow%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20earthy%20European%20aesthetic%2C%20organic%20minimal%20composition%2C%20trendy%20young%20style&width=600&height=600&seq=kako-feat-new-01&orientation=squarish",
  },
  {
    id: 2,
    titlePl: "Odzież",
    titleEn: "Clothing",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Stylish%20layered%20clothing%20arrangement%20on%20light%20sage%20green%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20modern%20European%20aesthetic%2C%20carefully%20folded%20textiles%2C%20gentle%20organic%20composition&width=600&height=600&seq=kako-feat-new-02&orientation=squarish",
  },
  {
    id: 3,
    titlePl: "Akcesoria",
    titleEn: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Elegant%20watch%20and%20sunglasses%20flat%20lay%20on%20light%20sandstone%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20modern%20European%20accessories%20display%2C%20minimal%20luxurious%20composition%2C%20warm%20neutral%20tones&width=600&height=600&seq=kako-feat-new-03&orientation=squarish",
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-4">
          Popularne kategorie
        </h2>
        <p className="text-center text-foreground-600 mb-12 max-w-xl mx-auto text-sm md:text-base">
          Trzy najczęściej wybierane kategorie produktów wśród polskich użytkowników Kakobuy Spreadsheet
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <a
              key={feat.id}
              href={feat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-square cursor-pointer"
            >
              <img
                src={feat.imageUrl}
                alt={`Kakobuy Spreadsheet ${feat.titlePl}`}
                title={`Kakobuy Spreadsheet ${feat.titlePl} — ${feat.titleEn}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 rounded-full text-xs font-semibold mb-2 whitespace-nowrap">
                  {feat.titleEn}
                </span>
                <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50">
                  {feat.titlePl}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}